import { eventInfo } from '../../data/landingData';
import { SpotsRemaining } from './Countdown';

export const FinalCTA = () => {
  return (
    <section 
      className="py-24 px-6 bg-gradient-to-b from-[#111111] to-[#0A0A0A] relative overflow-hidden"
      data-testid="final-cta-section"
    >
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#D4AF37]/10 rounded-full blur-3xl pointer-events-none" />
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
          Your Transformation Awaits
        </p>
        
        <h2 className="font-cormorant text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6">
          Ready to Begin Your Journey?
        </h2>
        
        <p className="text-zinc-400 font-manrope text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Join a brotherhood of men committed to growth, healing, and building legacy. 
          Your seat at the table is waiting.
        </p>

        {/* Spots remaining */}
        <div className="flex justify-center mb-8">
          <SpotsRemaining />
        </div>

        {/* CTA */}
        <a
          href="#pricing"
          className="inline-block bg-[#D4AF37] text-[#0A0A0A] px-12 py-5 rounded-full font-manrope font-bold text-xl hover:bg-[#B8860B] transition-all hover:-translate-y-1 gold-glow"
          data-testid="final-cta-button"
        >
          Secure Your Spot Today
        </a>

        {/* Event details */}
        <p className="text-zinc-600 font-manrope text-sm mt-6">
          {eventInfo.dates} • {eventInfo.location} • ${eventInfo.price.toLocaleString()}
        </p>
      </div>
    </section>
  );
};

export const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full overflow-hidden border border-[#D4AF37]/50 flex-shrink-0">
              <img
                src="https://customer-assets-4nw71qhi.emergentagent.net/job_analytics-live-1/artifacts/8w3x6659_brotherhood-reset-logo.jpg"
                alt="The Reset · The Brotherhood Circle"
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <p className="font-cormorant text-lg font-medium text-white">The Reset</p>
              <p className="font-manrope text-xs text-zinc-500">Black Men's Wellness Retreat</p>
            </div>
          </div>

          {/* Links */}
          <div className="flex items-center gap-8">
            <a href="#brotherhood" className="text-zinc-500 hover:text-white font-manrope text-sm transition-colors">
              About
            </a>
            <a href="#speakers" className="text-zinc-500 hover:text-white font-manrope text-sm transition-colors">
              Guides
            </a>
            <a href="#pricing" className="text-zinc-500 hover:text-white font-manrope text-sm transition-colors">
              Register
            </a>
            <a href="mailto:askcoachneil@gmail.com" className="text-zinc-500 hover:text-white font-manrope text-sm transition-colors">
              Contact
            </a>
          </div>

          {/* Copyright */}
          <p className="text-zinc-600 font-manrope text-sm">
            © 2026 The Reset. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
